/* eslint-disable */
import {
  GET_TEMPLATE_INFO_START,
  GET_TEMPLATE_INFO_SUCCESS,
  GET_TEMPLATE_INFO_FAIL,
  GET_TEMPLATES_START,
  GET_TEMPLATES_SUCCESS,
  GET_TEMPLATES_FAIL,
  CREATE_TEMPLATE_START,
  CREATE_TEMPLATE_SUCCESS,
  CREATE_TEMPLATE_FAIL,
  ARCHIVE_TEMPLATE_START,
  ARCHIVE_TEMPLATE_SUCCESS,
  ARCHIVE_TEMPLATE_FAIL,
  ACTIVATE_TEMPLATE_START,
  ACTIVATE_TEMPLATE_SUCCESS,
  ACTIVATE_TEMPLATE_FAIL,
  UPDATE_TEMPLATE_START,
  UPDATE_TEMPLATE_SUCCESS,
  UPDATE_TEMPLATE_FAIL,
  DELETE_TEMPLATE_START,
  DELETE_TEMPLATE_SUCCESS,
  DELETE_TEMPLATE_FAIL,
  GET_TIME_BOUNDS_START,
  GET_TIME_BOUNDS_SUCCESS,
  GET_TIME_BOUNDS_FAIL,
  GET_GROUPED_TEMPLATES_START,
  GET_GROUPED_TEMPLATES_SUCCESS,
  GET_GROUPED_TEMPLATES_FAIL,
  GET_MAILING_TRIGGERS_START,
  GET_MAILING_TRIGGERS_SUCCESS,
  GET_MAILING_TRIGGERS_FAIL,
  GET_BONUS_CARD_MAILING_TEMPLATES_START,
  GET_BONUS_CARD_MAILING_TEMPLATES_FAIL,
  GET_BONUS_CARD_MAILING_TEMPLATES_SUCCESS,
  CREATE_MAILING_FOR_BONUS_CARD_START,
  CREATE_MAILING_FOR_BONUS_CARD_FAIL,
  CREATE_MAILING_FOR_BONUS_CARD_SUCCESS,
  UPDATE_MAILING_FOR_BONUS_CARD_START,
  UPDATE_MAILING_FOR_BONUS_CARD_SUCCESS,
  UPDATE_MAILING_FOR_BONUS_CARD_FAIL,
  DELETE_MAILING_FOR_BONUS_CARD_START,
  DELETE_MAILING_FOR_BONUS_CARD_FAIL,
  DELETE_MAILING_FOR_BONUS_CARD_SUCCESS
} from './constants';

export const mailingReducer = (
  state = {
    template: {},
    templates: {},
    groupedTemplates: {},
    bonusCardTemplates: [],
    fetching: false,
    timeBounds: [],
    error: null,
    createUpdateError: null,
    archiveError: null,
    triggers: [],
  },
  action
) => {
  switch (action.type) {
    case GET_TEMPLATES_START:
      return { ...state, fetching: true, templates: [], error: null };
    case ARCHIVE_TEMPLATE_START:
      return { ...state, fetching: true, archiveError: null };
    case GET_TEMPLATE_INFO_START:
    case GET_TIME_BOUNDS_START:
    case DELETE_TEMPLATE_START:
    case ACTIVATE_TEMPLATE_START:
    case GET_GROUPED_TEMPLATES_START:
    case GET_MAILING_TRIGGERS_START:
    case CREATE_MAILING_FOR_BONUS_CARD_START:
    case UPDATE_MAILING_FOR_BONUS_CARD_START:
    case DELETE_MAILING_FOR_BONUS_CARD_START:
      return { ...state, fetching: true, error: null };

    case CREATE_TEMPLATE_START:
    case UPDATE_TEMPLATE_START:
      return { ...state, fetching: true, createUpdateError: null };

    case GET_BONUS_CARD_MAILING_TEMPLATES_START:
      return { ...state, fetching: true, bonusCardTemplates: [], error: null };

    case GET_TEMPLATE_INFO_SUCCESS:
      return { ...state, template: action.payload, fetching: false };

    case GET_TEMPLATES_SUCCESS:
      return { ...state, templates: action.payload, fetching: false };

    case GET_GROUPED_TEMPLATES_SUCCESS:
      return { ...state, groupedTemplates: action.payload, fetching: false };

    case GET_BONUS_CARD_MAILING_TEMPLATES_SUCCESS:
      return { ...state, bonusCardTemplates: action.payload, fetching: false };

    case GET_TIME_BOUNDS_SUCCESS:
      return { ...state, timeBounds: action.payload, fetching: false };

    case GET_MAILING_TRIGGERS_SUCCESS:
      return { ...state, triggers: action.payload, fetching: false };

    case CREATE_MAILING_FOR_BONUS_CARD_SUCCESS:
      return {
        ...state,
        bonusCardTemplates: [
          ...state.bonusCardTemplates,
          action.payload?.data?.instance,
        ],
        fetching: false,
      };

    case UPDATE_MAILING_FOR_BONUS_CARD_SUCCESS:
      return {
        ...state,
        bonusCardTemplates: [
          ...state.bonusCardTemplates?.filter((template) => template?.id !== action.payload?.id),
          action.payload,
        ],
        fetching: false,
      };

    case DELETE_MAILING_FOR_BONUS_CARD_SUCCESS:
      return {
        ...state,
        bonusCardTemplates: [
          ...state.bonusCardTemplates?.filter((template) => template?.id !== action.payload?.data.instance.id),
        ],
        fetching: false,
      };

    case CREATE_TEMPLATE_SUCCESS:
      return {
        ...state,
        fetching: false,
        templates: {
          ...state.templates,
          ...action.payload?.instance,
        }
      };

    case UPDATE_TEMPLATE_SUCCESS:
      return { ...state, fetching: false };

    case ARCHIVE_TEMPLATE_SUCCESS:
      return {
        ...state,
        fetching: false,
        template: { ...state.template, status: 'archive' },
        templates: {
          ...state.templates,
          items: state.templates?.items?.map((template) =>
            template?.id === action.payload?.id ? { ...template, status: 'archive' } : template
          )
        }
      };

    case ACTIVATE_TEMPLATE_SUCCESS:
      return {
        fetching: false,
        template: { ...state.template, status: 'created' },
        templates: {
          ...state.templates,
          items: state.templates?.items?.map((template) =>
            template?.id === action.payload?.id ? { ...template, status: 'created' } : template
          )
        }
      };

    case DELETE_TEMPLATE_SUCCESS:
      return {
        ...state,
        fetching: false,
        template: null,
        templates: {
          ...state.templates,
          items: state.templates?.items?.filter((template) => template?.id !== action.payload?.id)
        }
      };

    case GET_TEMPLATE_INFO_FAIL:
    case GET_TEMPLATES_FAIL:
    case GET_TIME_BOUNDS_FAIL:
    case DELETE_TEMPLATE_FAIL:
    case ACTIVATE_TEMPLATE_FAIL:
    case GET_GROUPED_TEMPLATES_FAIL:
    case GET_MAILING_TRIGGERS_FAIL:
    case GET_BONUS_CARD_MAILING_TEMPLATES_FAIL:
    case CREATE_MAILING_FOR_BONUS_CARD_FAIL:
    case UPDATE_MAILING_FOR_BONUS_CARD_FAIL:
    case DELETE_MAILING_FOR_BONUS_CARD_FAIL:
      return { ...state, error: action.payload, fetching: false };

    case ARCHIVE_TEMPLATE_FAIL:
      return { ...state, archiveError: action.payload, fetching: false };

    case CREATE_TEMPLATE_FAIL:
    case UPDATE_TEMPLATE_FAIL:
      return { ...state, createUpdateError: action.payload, fetching: false };

    default:
      return state
  }
};
